export default "__VITE_ASSET__DDeD17ba__"